import cx from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { Table, TableBody } from 'semantic-ui-react';
import * as api from '../../../stores/api';
import { Link } from 'react-router-dom';
import {
  TableEmptyMessage,
  TableFooterPagination,
  TableHeader,
} from '../../shared/table';
import ServiceFeeStore from './AMAServiceFeeStore';

const columns = [
  { title: 'AMA Code' },
  { title: 'MBS Code' },
  { title: 'Service Type' },
  { title: 'Type of Procedures' },
  { title: 'Description' },
  { title: 'Fee' },
  { title: 'Exclusion Codes' },
  { title: 'Status' },
  { title: 'Published Year' },

];

@observer
class ServiceFeeTable extends React.Component {
  openModal = options => {
    return ServiceFeeStore.toggleModal(true, options);
  };

  openModalEdit = (id, record) => {
    return ServiceFeeStore.toggleModal(true, {
      modalType: 'createServiceFee',
      id,
      record,
    });
  };

  renderExclusionCode = (record) => {
    if (record.ListExcludedAMACode) {
      return record.ListExcludedAMACode.map((ex) => {
        return <label key={ex.Id} className='ui label' style={{ margin: '2px' }}> {ex.ExcludedAMACode}</label>
      })
    }
    return null;
  }

  renderTableBody = (data, colSpan) => {
    if (!data || !data.itemList.length) {
      return <TableEmptyMessage colSpan={colSpan} />;
    }

    return data.itemList.map(({ Id, ...record }) => (
      <Table.Row key={Id} negative={record.Status !== 0}>
        <Table.Cell
          selectable
          className={cx({ 'Cell-nowrap Cell-link': record.Status === 0 })}
        >
          {api.isAdmin() ?
            <Link to="#" onClick={this.openModalEdit(Id, record)} style={{ color: `#9f3a38` }}>{record.AMACode}</Link>
            : record.AMACode
          }
        </Table.Cell>
        <Table.Cell>{record.MBSCode}</Table.Cell>
        <Table.Cell>{record.ServiceType}</Table.Cell>
        <Table.Cell>{record.TypeProcedures}</Table.Cell>
        <Table.Cell>{record.Description}</Table.Cell>
        <Table.Cell>
          ${record.Fee === null ? 0 : record.Fee}
        </Table.Cell>
        <Table.Cell>
          {this.renderExclusionCode(record)}
        </Table.Cell>
        <Table.Cell>{record.StatusText}</Table.Cell>
        <Table.Cell>{record.PublishedYear}</Table.Cell>
      </Table.Row>
    ));
  };


  handlePageClick = page => {
    ServiceFeeStore.refetch({ curPage: page });
  };

  render() {
    const { data, loading, sortColumn, sortDirection } = ServiceFeeStore;
    const column = api.isAdmin()
      ? columns.map(i => i)
      : columns.filter(i => i.title !== '').map(i => i);
    const colSpan = column.length;
    return (
      <Table sortable striped celled className={cx({ disabled: loading })}>
        <TableHeader
          columns={column}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
        />
        <TableBody>{this.renderTableBody(data, colSpan)}</TableBody>
        <TableFooterPagination
          colSpan={colSpan}
          currentPage={ServiceFeeStore.curPage}
          totalPage={ServiceFeeStore.totalPage}
          totalItems={ServiceFeeStore.totalItems}
          onPageClick={this.handlePageClick}
        />
      </Table>
    );
  }
}

export default ServiceFeeTable;
